import { useMutation, useQueryClient } from '@tanstack/react-query'

import type { BookingSessionResponse } from '../../types/booking-session.js'

import { apiClient } from '../../lib/client.js'
import { syncBookingSessionCache } from './cache.js'

export interface SubmitDepositReservationRequest {
  buyerEmail?: string
  buyerPhone?: string
  subscribeToNotifications?: boolean
}

export const useSubmitDepositReservation = (sessionId: string) => {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: async (data: SubmitDepositReservationRequest) => {
      const response = await apiClient.client.post<BookingSessionResponse>(
        `/booking-session/${sessionId}/deposit-reservation`,
        data
      )
      return response.data
    },
    onSuccess: (data) => {
      syncBookingSessionCache(queryClient, data)
    },
  })
}
